import React from 'react';
import summary_ok from '../../img/summary_ok.gif';
import Header from '../header/Header';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { addComplaintPosition, clearComplaintPositions, setPositions } from '../../features/complaintPositions/ComplaintPositionsSlice';
import { clearAllPositions } from '../../features/complaintPosition/ComplaintPositionSlice';
import { clearFiles } from '../../features/files/FileSlice';
import { clearProducts } from '../../features/products/productSlice';
import './SuccessfulComplaint.scss'

const SuccessfulComplaint = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  const customer = useSelector((state)=>state.customer);
  const [complaintSubmitted, setComplaintSubmitted] = useState(sessionStorage.getItem('complaintSubmitted') === 'true');
  const positions = useSelector(state=>state.complaintPositions.positions)

  console.log(positions);
  // useEffect(() => {
  //   sessionStorage.setItem('complaintSubmitted', complaintSubmitted ? 'true' : 'false');
  // }, [complaintSubmitted]);
  
  useEffect(() => {
    function handlePageChange() {
        setCurrentPage(window.location.pathname);
    }
    window.addEventListener("popstate", handlePageChange);
    return () => {
        window.removeEventListener("popstate", handlePageChange);
    };
}, [currentPage]);


const handleNewComplaintClick = () => {
  setCurrentPage('customers');
  navigate('/customers');
  dispatch(clearComplaintPositions());
  dispatch(clearAllPositions())
  dispatch(clearFiles());
  dispatch(clearProducts());
  setComplaintSubmitted(true);
  sessionStorage.setItem('complaintSubmitted', 'true');
};

const handleStart = () => {
  setCurrentPage('send');
  navigate('/');
  setComplaintSubmitted(false);
  sessionStorage.setItem('complaintSubmitted', 'false');
  window.location.reload();
};
  return (
    <div>
        <Header/>
        <div className='successful-complaint-container'>
          <div className='send-complaint-container'>
            <img className="img-ok" src={summary_ok}/>

            <h4 className='main-text'>Twoje zgłoszenie zostało wysłane</h4>
            <div className="body-text">
                <p>O zmianach w obsłudze zgłoszenia poinformujemy Cię mailowo, na podany przez Ciebie adres: <b>{customer.email}</b></p>
                <p>Mail z numerem reklamacji wyślemy do 24h</p>
            </div>
          </div>
          <div className='successful-complaint-buttons-container'>
          <button className="add-new-complaint-btn"><p className="add-new-complaint-text" onClick={handleNewComplaintClick}>Dodaj nowe zgłoszenie</p></button>
          <Link className="back-to-start" style={{textTransform:"none"}} onClick={handleStart}>Wróć na stronę główną</Link>
          </div>
        </div>
    </div>
  )
}

export default SuccessfulComplaint;